// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"06ddc5da","84":"c51e29fe","122":"f4955c66","144":"b2c46ef9","269":"d4267d7b","453":"0b1e3c68","455":"f91f4bd8","466":"a8e1cda8","514":"7a69b729","559":"0a18d79f","577":"7f454954","634":"86dfc897","663":"4c9d7635","667":"799c733a","964":"6830497a"}[chunkId] + ".chunk.js";
};